// import classNames from 'classnames';
// import { HTMLAttributes, PropsWithChildren } from 'react';
// import { Dropdown } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { IconProp } from '@fortawesome/fontawesome-svg-core';
// import { faEllipsis } from '@fortawesome/free-solid-svg-icons';

// interface RevealDropdownTriggerProps extends HTMLAttributes<HTMLDivElement> {
//   className?: string;
// }

// interface RevealDropdownProps {
//   className?: string;
//   btnClassName?: string;
//   dropdownMenuClassName?: string;
//   icon?: IconProp;
// }

// export const RevealDropdownTrigger = ({
//   children,
//   className,
//   ...rest
// }: PropsWithChildren<RevealDropdownTriggerProps>) => {
//   return (
//     <div
//       className={classNames('btn-reveal-trigger position-relative', className)}
//       {...rest}
//     >
//       {children}
//     </div>
//   );
// };

// const RevealDropdown = ({
//   children,
//   className,
//   btnClassName,
//   dropdownMenuClassName,
//   icon = faEllipsis
// }: PropsWithChildren<RevealDropdownProps>) => {
//   const popperConfig = {
//     strategy: 'fixed' as const, // 'absolute' | 'fixed'
//     modifiers: [
//       {
//         name: 'preventOverflow',
//         options: { boundary: 'viewport', altBoundary: true }
//       },
//       {
//         name: 'flip',
//         options: { boundary: 'viewport', altBoundary: true }
//       }
//     ]
//   };

//   return (
//     <Dropdown className={classNames('dropdown', className)} align="end">
//       <Dropdown.Toggle
//         variant=""
//         size="sm"
//         className={classNames(
//           btnClassName,
//           'btn btn-sm bg-white border border-300 rounded d-flex align-items-center justify-content-center shadow-none transition-base dropdown-toggle-hide-caret ms-3'
//         )}
//         aria-label="Open menu"
//       >
//         <FontAwesomeIcon icon={icon} className="text-body fs-9" />
//       </Dropdown.Toggle>

//       <Dropdown.Menu
//         align="end"
//         className={classNames(
//           dropdownMenuClassName,
//           'dropdown-menu dropdown-menu-end bg-white border border-300 shadow-sm py-2 rounded'
//         )}
//         popperConfig={popperConfig} // <-- control positioning here
//         renderOnMount
//       >
//         {children}
//       </Dropdown.Menu>
//     </Dropdown>
//   );
// };

// export default RevealDropdown;

import classNames from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { Dropdown } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

interface RevealDropdownTriggerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

interface RevealDropdownProps {
  className?: string;
  btnClassName?: string;
  dropdownMenuClassName?: string;
  buttonText?: string;
}

export const RevealDropdownTrigger = ({
  children,
  className,
  ...rest
}: PropsWithChildren<RevealDropdownTriggerProps>) => {
  return (
    <div
      className={classNames('btn-reveal-trigger position-relative', className)}
      {...rest}
    >
      {children}
    </div>
  );
};

const RevealDropdown = ({
  children,
  className,
  btnClassName,
  dropdownMenuClassName,
  buttonText = 'Actions' // Default text is "Actions"
}: PropsWithChildren<RevealDropdownProps>) => {
  const popperConfig = {
    strategy: 'fixed' as const,
    modifiers: [
      {
        name: 'preventOverflow',
        options: { boundary: 'viewport', altBoundary: true }
      },
      {
        name: 'flip',
        options: { boundary: 'viewport', altBoundary: true }
      }
    ]
  };

  return (
    <Dropdown className={classNames('dropdown', className)} align="end">
      <Dropdown.Toggle
        variant=""
        size="sm"
        className={classNames(
          btnClassName,
          'btn btn-sm',
          'rounded d-flex align-items-center justify-content-center',
          'shadow-none transition-base dropdown-toggle-hide-caret',
          'p-0 border-0'
        )}
        style={{
          width: '32px',
          height: '32px',
          color: '#6b7280'
        }}
        aria-label="Open menu"
      >
        <FeatherIcon icon="more-horizontal" size={18} />
      </Dropdown.Toggle>

      <Dropdown.Menu
        align="end"
        className={classNames(
          dropdownMenuClassName,
          'dropdown-menu dropdown-menu-end bg-white border border-300 shadow-sm py-2 rounded'
        )}
        popperConfig={popperConfig}
        renderOnMount
      >
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RevealDropdown;
